import React from "react"
import styled from "styled-components"
import Background from "../images/background-1.svg"
import styles from "./styles/HomeService.module.scss"
import Card from "./Card"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import CardTopIcon from "./CardTopIcon"
import ID from "../images/id.svg"
import Globe from "../images/globe.svg"
import Money from "../images/money.svg"
import Button from "./Button"

const ServicesContainer = styled.div`
background: #000428;  
background: -webkit-linear-gradient(45deg, #004e92, #000428);  
background: linear-gradient(45deg, #004e92, #000428); 
position: relative;
width: 100%;
padding: 1px 0 10vh 0;
min-height: 1100px;
@media only screen and (min-width: 2000px) {
min-height: 1600px;
}
`

const BackgroundContainer = styled.div`
position: absolute;
left: 50%;
transform: translateX(-50%);
bottom: 0;
width: 100%;


`

const BackgroundBanner = styled.img`
  position: absolute;
  margin: 0;
  bottom: -1px;
  left: -1px;
  right: -1px;
  float: left;

`

const ServiceHolder = styled.div`
margin: 10vh 0 0 0;
postion: relative;
z-index: 5;
`

const CardHeader = styled.h6`
text-align: center;
font-family: "Montserrat", serif;
color: #004e92;
font-weight: 700;
margin: 64px 0 3vh 0;
`

const ServiceTitle = styled.h3`
text-align: center;
font-family: "Montserrat", serif;
color: #004e92;
font-weight: 700;
`

const ServiceBreak = styled.hr`
width: ${props => props.w ? props.w : "200px"};
height: 10px;
background-color: ${props => props.c ? props.c : "#CE0101"};
display: block;
margin: 1rem auto 1.5rem auto;
`

const SectionHeader = styled.h2`
text-align: center;
font-family: "Montserrat", serif;
color: #fff;
font-weight: 700;
margin: 3rem 0 0 0;
`

const SectionParagraph = styled.p`
  margin: 1rem 0 1rem 0;
`

const HomeServicesSpanish = (props) => {
  const columnClasses = "columns spacer"
  const data = useStaticQuery(graphql`
      query HomeServicesSpanishQuery {
          file(relativePath: {eq: "Repair-1.jpg"}) {
              id
              childImageSharp {
                  fluid(maxWidth: 800) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (
    <ServicesContainer>
      <SectionHeader>Why Us</SectionHeader>
      <ServiceBreak c="#fff" w="400px"/>
      <BackgroundContainer>
        <svg style={{ fill: "#fff", position: "absolute", bottom: "0" }} xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 1888 924.67">
          <path className="a"
                d="M1888,924.65H0V0A1436.19,1436.19,0,0,1,358.67,329.49c60.95,78.75,150.64,170.62,246.19,315.72,42.62,64.71,66.5,107.57,118.47,157.82,48.14,46.54,124.53,120.41,228,121.62,124.46,1.46,215.82-103,266-160.43,41.64-47.62,47.26-68.6,109.93-164.75,0,0,94.68-132.91,203.41-275.15A1329.55,1329.55,0,0,1,1888,0Z"/>
        </svg>
      </BackgroundContainer>


      <ServiceHolder>
        <div className="container if-fullhd">

          <div className={columnClasses}>

            <div className="column is-one-third-desktop is-half-tablet is-12 is-flex">
              <Card>
                <CardTopIcon w={64} h={64} src={ID} alt="ID"/>
                <CardHeader>Antecedentes Verificados</CardHeader>
                <p>Para la seguridad de nuestros clientes y sus familias, todos nuestros técnicos están autorizados por
                  el estado de Texas y se han hecho una revisión de antecedentes penales.</p>
              </Card>
            </div>
            <div className="column is-one-third-desktop is-half-tablet is-12 is-flex">
              <Card>
                <CardTopIcon w={64} h={64} src={Globe} alt="Globe"/>
                <CardHeader>Servimos a todas las marcas</CardHeader>
                <p>¿Por qué molestarse con múltiples compañías diferentes cuando puedes conseguir todas tus
                  instalaciones, actualizaciones y reparaciones hechas por nosotros para cualquier marca?</p>
              </Card>
            </div>
            <div className="column is-one-third-desktop is-half-tablet is-12 is-flex">
              <Card>
                <CardTopIcon w={64} h={64} src={Money} alt="Image of money"/>
                <CardHeader>Precios Asequibles</CardHeader>
                <p>Con grandes precios en todo, desde reparaciones de HVAC hasta nuevas instalaciones comerciales junto
                  con nuestra financiación a bajo interés, ¡ahorrarás tiempo y dinero!</p>
              </Card>
            </div>
          </div>


          <div className={columnClasses}>
            <div className="column is-12">
              <Card highlight="blue" p={"3rem 2rem"}>
                <div className="columns">
                  <div className="column is-half">
                    <Img className="circleImg" fluid={data.file.childImageSharp.fluid}/>
                  </div>
                  <div className="column is-half">
                    <ServiceTitle>Quiénes Somos</ServiceTitle>
                    <ServiceBreak/>
                    <SectionParagraph>Air Service Experts es una compañía de servicio completo de aire acondicionado y calefacción que ofrece nuevos
                      instalaciones, reparaciones, mantenimiento para clientes comerciales y residenciales. En nuestro trabajo
                      a lo largo de Mission, McAllen, Edinburg, Mercedes, Weslaco, y todo el Valle del Río Grande, estamos
                      reconocido por nuestro alto nivel de trabajo y piezas. Nos atenemos a las normas más estrictas
                      para asegurarse de que sus unidades de HVAC estén en plena forma durante los próximos años.
                    </SectionParagraph>
                    <SectionParagraph>Tenemos más de 25 años de experiencia trabajando en el Valle del Río Grande y trabajamos
                      con todas y cada una de las marcas de la industria de la calefacción y la refrigeración. Hemos instalado con éxito
                      cientos de unidades comerciales y residenciales y reparó miles más.</SectionParagraph>
                    <Button href="/contact" m="2rem 0 0 0">Contáctenos</Button>
                  </div>
                </div>

              </Card>
            </div>
          </div>


        </div>


      </ServiceHolder>


    </ServicesContainer>
  )
}


export default HomeServicesSpanish
